import { toTimestamp } from '../utils/addWebSocketToReplication'
import { createReplication } from './createReplication'
import type { PlanCollection } from '../index'

/**
 * Setup replication for plans
 * Plans are global, not workspace-specific (all users see same plans)
 * Read-only from client side (admin-only updates)
 */
export const setupPlanReplication = (collection: PlanCollection) =>
  createReplication({
    entityName: 'plans',
    displayName: 'Plan',
    collection,
    useWebSocket: false,
    usePurgeFilter: false,
    mapFromServer: (doc) => ({
      id: doc.id,
      code: doc.code,
      name: doc.name,
      description: doc.description,
      priceMonthly: doc.priceMonthly,
      priceAnnual: doc.priceAnnual,
      currency: doc.currency,
      limits: doc.limits,
      features: doc.features,
      isPublic: doc.isPublic,
      sortOrder: doc.sortOrder,
      highlightText: doc.highlightText,
      ctaText: doc.ctaText,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    // No mapToServer - plans are read-only from client
  })
